
define('customBindings',['knockout', 'jquery', 'lodash', 'moment', "current-locale", "placeholder", 'ko-t', 'bootstrap', 'datepicker'], function (ko, $, _, moment, locale, placeholder) {
    ko.bindingHandlers.expandToggle = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            if (val) {
                $(element).show();
            } else {
                $(element).hide();
            }
        }
    };

    /*ko.bindingHandlers.stopPropagation = {
        init: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            var ele = $(element);
            ele.on('click.datepicker.data-api', function () {
                ele.data('datepicker').picker.on('click', function (e) {
                    e.stopPropagation();
                });
            });
        }
    };*/

    ko.bindingHandlers.fadeVisible = {
        init: function (element, valueAccessor) {
            // Initially set the element to be instantly visible/hidden depending on the value
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn("fast") : $(element).fadeOut(); // Use "unwrapObservable" so we can handle values that may or may not be observable
        },
        update: function (element, valueAccessor) {
            // Whenever the value subsequently changes, slowly fade the element in or out
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn("fast") : $(element).fadeOut();
        }
    };

    ko.bindingHandlers.koHtml = {
        init: function () {
            return ko.bindingHandlers["with"].init.apply(this, arguments);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var accessor = valueAccessor();
            var subVM = ko.unwrap(accessor.subViewModel) || bindingContext.$data;
            var context = subVM !== bindingContext.$data ? bindingContext.createChildContext(subVM) : bindingContext;
            ko.virtualElements.emptyNode(element);
            var childElems = $(ko.unwrap(valueAccessor().html)).get();
            childElems = _(childElems).reject(function (x) { return x.nodeType === 3; }).value();
            ko.virtualElements.setDomNodeChildren(element, childElems);
            ko.applyBindingsToDescendants(context, element);
        }
    };

    ko.virtualElements.allowedBindings.koHtml = true;

    ko.bindingHandlers.modal = {
        init: function (element, valueAccessor, allBindings) {
            var data = valueAccessor();

            //make sure that we clear the observable no matter how the modal is closed
            $(element).modal({ show: false }).on("hidden.bs.modal", function () {

                if (ko.isWriteableObservable(data)) {
                    data(null);
                }
            });

            var hidbind = allBindings.get('hide');
            var showbind = allBindings.get('show');
            if (hidbind) {
                $(element).on("hidden.bs.modal", hidbind);
            }
            if (showbind) {
                $(element).on("shown.bs.modal", showbind);
            }
        },
        update: function (element, valueAccessor) {
            var data = ko.utils.unwrapObservable(valueAccessor());
            //show or hide the modal depending on whether the associated data is populated
            if (data) {
                $(element).modal("show");
                window.setTimeout(function() {
                    placeholder(element); // apply placeholder-labels
                }); // KLUDGE - TODO: Figure out how to apply placeholder labels immediately
            } else {
                $(element).modal("hide");
            }
        }
    };
    ko.bindingHandlers.date = {
        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var value = valueAccessor();
            var formatString = allBindingsAccessor().formatString;
            var date = moment(ko.unwrap(value));
            if (formatString === null) {
                $(element).text(date.lang(locale() || 'en').format(ko.translate("Moment.M/D/YYYY") + ', h:mm:ss a'));
            } else {
                $(element).text(date.lang(locale() || 'en').format(formatString));
            }
        }
    };

    ko.bindingHandlers.datepicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            //initialize datepicker with some optional options
            var options = allBindingsAccessor().datepickerOptions || {};
            options.language = locale();

            if (options.nested) {
                $(element).on('click.datepicker.data-api', function () {
                    $(this).data('datepicker').picker.on('click', function (e) {
                        e.stopPropagation();
                    });
                });
                delete options.nested;
            }

            $(element).datepicker(options);

            //when a user changes the date, update the view model
            $(element).on("change", function (event) {
                if ($(element).val() != "") {
                    var value = valueAccessor();
                    if (ko.isObservable(value)) {
                        value(moment($(element).datepicker("getDate")).toISOString());
                    }
                }
            });
        },
        update: function (element, valueAccessor, allBindingsAccessor) {
            if ($(element).data('datepicker').o.language !== locale()) {
                var options = allBindingsAccessor().datepickerOptions || {};
                options.language = locale();
                $(element).datepicker('remove');
                $(element).datepicker(options);
            }
            $(element).data().datepicker.dates.pop();
            var dt = ko.utils.unwrapObservable(valueAccessor());
            if (dt != '0001-01-01T00:00:00') {
                $(element).datepicker('update', moment(dt).toDate());
            }
        }
    };

    ko.bindingHandlers.typeahead = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var source = ko.utils.unwrapObservable(valueAccessor());
            var displayKey = allBindingsAccessor().displayKey || {};
            var name = allBindingsAccessor().name || {};
            var target = allBindingsAccessor().target || {};

            $(element).typeahead({
                highlight: true,
                hint: true
            }, {
                displayKey: displayKey,
                name: name,
                source: source,
                templates: {
                    empty: [
                      '<div class="no-results">',
                      'No results found',
                      '</div>'
                    ].join('\n')
                }
            }).on('typeahead:opened', function () {
                $('.tt-dropdown-menu').css('width', $(element).width() + 'px');
            }).on("typeahead:selected", function (sender, suggestion) {
                target(suggestion);
                $(element).typeahead("val", "");
            });
        }
    };

    ko.bindingHandlers.inIndexView = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var viewArr = valueAccessor();
            var baseArr = allBindingsAccessor.get('foreach') || [];
            var update = function (event) {
                if (ko.isObservable(valueAccessor())) {
                    $el = $(element);
                    var itemHeight = $el[0].scrollHeight / ko.unwrap(baseArr).length;

                    var start = $el.scrollTop() / itemHeight;
                    var end = ($el.scrollTop() + $el.height()) / itemHeight;

                    var startIndex = (start % 1) > 0.85 ? start - (start % 1) + 1 : start - (start % 1);
                    var endIndex = (end % 1) <= 0.15 ? end - (end % 1) - 1 : end - (end % 1);
                    viewArr([startIndex, endIndex]);
                }
            };

            $(element).on('scroll', update);
            $(element).on('resize', update);
            setTimeout(update, 1000);
        }
    };

    ko.bindingHandlers.resize = {
        init: function (element) {
            $(element).resizable({ handles: "s" });
        }
    };

    ko.bindingHandlers.tooltip = {
        init: function (element) {
            $(element).tooltip();
        }
    };
});